import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const normalizeMetricsResponse = (response: any) => response?.data?.data ?? response?.data ?? {};

export const useGetSplotProcessingMetrics = (enabled: boolean, siteCode: string) => {
    return useQuery({
        queryKey: ['kpi-processing-metrics', siteCode],
        queryFn: ({ signal }) => axios.get(`/api/v1/splot-processing-metrics/${encodeURIComponent(siteCode || '')}`, { signal }),
        select: normalizeMetricsResponse,
        enabled: enabled && !!siteCode,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: true,
    });
};

export const useGetTrailProcessingMetrics = (enabled: boolean, siteCode: string) => {
    return useQuery({
        queryKey: ['kpi-trial-processing-metrics', siteCode],
        queryFn: ({ signal }) => axios.get(`/api/v1/trial-processing-metrics/${encodeURIComponent(siteCode || '')}`, { signal }),
        select: normalizeMetricsResponse,
        enabled: enabled && !!siteCode,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: true,
    });
};
